import { render, staticRenderFns } from "./ShareInstanceModal.vue?vue&type=template&id=1c48cab8&scoped=true"
import script from "./ShareInstanceModal.vue?vue&type=script&lang=js"
export * from "./ShareInstanceModal.vue?vue&type=script&lang=js"
import style0 from "./ShareInstanceModal.scss?vue&type=style&index=0&id=1c48cab8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c48cab8",
  null
  
)

export default component.exports